import type { LoginProblem } from '@zinc/shared';
import { useSearchParams } from 'react-router';
import { Wordmark } from '../components/AppShell';
import { Card } from '../components/ui';

const MESSAGES: Record<LoginProblem | 'loggedOut' | 'none', { title: string; body: string }> = {
  none: { title: 'Log in', body: 'ZincSudoku uses your Chestrose account.' },
  loggedOut: { title: 'You’re logged out', body: 'Log in again with your Chestrose account.' },
  not_allowed: {
    title: 'Not allowed',
    body: 'This Chestrose account isn’t one of the two ZincSudoku accounts. Log in to Chestrose with your own account and try again.',
  },
  no_token: {
    title: 'Couldn’t log you in',
    body: 'Chestrose didn’t send a login back. Try again in a moment.',
  },
  unconfigured: {
    title: 'Chestrose login isn’t available here',
    body: 'Chestrose can only log you in on zincsudoku.chestrose.com. For local development set AUTH_DEV_USER.',
  },
};

function problemFrom(params: URLSearchParams): keyof typeof MESSAGES {
  const error = params.get('error');
  if (error === 'not_allowed' || error === 'no_token' || error === 'unconfigured') return error;
  if (params.get('loggedOut') === '1') return 'loggedOut';
  return 'none';
}

/** Where /auth/login sends a browser it couldn't log in, and where logging out lands. */
export function LoginPage() {
  const [params] = useSearchParams();
  const message = MESSAGES[problemFrom(params)];
  return (
    <main className="mx-auto flex min-h-dvh max-w-[420px] flex-col justify-center gap-5 px-4">
      <div className="flex items-center gap-3">
        <img src="/icons/icon.svg" alt="" width={44} height={44} />
        <Wordmark />
      </div>
      <Card className="flex flex-col gap-3 px-4 py-5">
        <h1 className="m-0 text-[20px] font-bold">{message.title}</h1>
        <p className="m-0 text-[15px] text-muted">{message.body}</p>
        <a
          href="/auth/login"
          className="flex h-12 items-center justify-center rounded-[12px] bg-accent text-[16px] font-bold text-white no-underline hover:text-white"
        >
          Log in with Chestrose
        </a>
      </Card>
    </main>
  );
}
